import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-icons/iconfont/material-icons.css'

import { getWhitelabelConfiguration } from '@/plugins/whitelabel/whitelabel.js'

const whitelabelConfiguration = getWhitelabelConfiguration(process.env.VUE_APP_WHITELABEL)

const vuetifyOptions = {
  theme: {
    dark: false,
    themes: whitelabelConfiguration.themes,
  },
}

Vue.use(Vuetify)

export default new Vuetify(vuetifyOptions)
